module.exports = __webpack_public_path__ + "9a003bb773f05f1cfe0081b39cc5901a.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-10.png
// module id = 97
// module chunks = 0